/**
 * Périodes partagées par les blocs du dashboard stock, pour que les onglets
 * proposent les mêmes choix et les calculent de la même façon.
 */

export function toInputDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return date.getFullYear() + '-' + month + '-' + day;
}

export function buildPeriodPresets() {
    const now = new Date();
    const quarterStartMonth = Math.floor(now.getMonth() / 3) * 3;

    return [
        {
            key: 'month',
            label: 'Mois en cours',
            start: toInputDate(new Date(now.getFullYear(), now.getMonth(), 1)),
            end: toInputDate(new Date(now.getFullYear(), now.getMonth() + 1, 0)),
        },
        {
            key: 'quarter',
            label: 'Trimestre en cours',
            start: toInputDate(new Date(now.getFullYear(), quarterStartMonth, 1)),
            end: toInputDate(new Date(now.getFullYear(), quarterStartMonth + 3, 0)),
        },
        {
            key: 'year',
            label: 'Année en cours',
            start: toInputDate(new Date(now.getFullYear(), 0, 1)),
            end: toInputDate(new Date(now.getFullYear(), 11, 31)),
        },
        {
            key: 'previous_year',
            label: 'Année précédente',
            start: toInputDate(new Date(now.getFullYear() - 1, 0, 1)),
            end: toInputDate(new Date(now.getFullYear() - 1, 11, 31)),
        },
        {
            key: 'all',
            label: "Cumul depuis l'origine",
            start: '',
            end: '',
        },
    ];
}
